import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import NavbarDropshipping from '../navbarDropshipping/navbarDropshipping';
import axios from 'axios';
import './ProductCard.css';
import SendClientPage from "../SendClientPage/SendClientPage";
import CloseIcon from '@mui/icons-material/Close';
import { message, Button } from 'antd'; // added antd imports

const ProductCard = () => {
  const [mostrarEnvios, setMostrarEnvios] = useState(false);
  const [suggestedPrice, setSuggestedPrice] = useState(null);
  const [name, setName] = useState(null);
  const [stock, setStock] = useState(null);
  const [prodID, setProdID] = useState(null);
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [sucursal, setSucursal] = useState(null);
  const [selectedImage, setSelectedImage] = useState("");
  const [estadoBodega, setEstadoBodega] = useState(false);
  const [inventarioBodega, setInventarioBodega] = useState([]);
  const [isSubscribed, setIsSubscribed] = useState(false); // New state for subscription
  const [idSucursal, setIdSucursal] = useState(null); // Nuevo estado para id_sucursal

  const handleButtonClick = (suggestedPrice, stock, name, prodID) => {
    setMostrarEnvios(true);
    setSuggestedPrice(suggestedPrice);
    setStock(stock);
    setName(name);
    setProdID(prodID);
  };

  const handleCloseModal = () => {
    setMostrarEnvios(false);
  };

  // Nueva función para manejar el cierre desde el hijo
  const handleSendClientModalClose = () => {
    setMostrarEnvios(false);
  };

  const getCategoryName = (categoryId) => {
    const categoryMap = {
      1: "Bisuteria",
      2: "Ropa Deportiva",
      3: "Vaporizadores",
      4: "Mascotas",
      5: "Moda",
      6: "Tecnologia",
      7: "Cocina",
      8: "Belleza",
      9: "Salud",
      10: "Hogar",
      11: "Natural Home",
      12: "Deportes",
      13: "Sex Shop",
      14: "Bebé",
      15: "Aseo",
      16: "Bienestar",
      17: "Camping",
      18: "Pesca",
      19: "Defensa Personal",
      20: "Vehiculos",
      21: "Jugueteria",
      22: "Otros"
    };
    return categoryMap[categoryId] || 'Sin categoría';
  };

  useEffect(() => {
    const fetchProduct = async () => {
      const url = `https://api.99envios.app/api/inventarios_producto/${id}`;
      try {
        const { data } = await axios.get(url);
        const foundProduct = data.inventario;
        if (foundProduct) {
          setProduct(foundProduct);
          setSucursal(data.sucursal);
          setSelectedImage(foundProduct.imagenes[0]?.url_imagen || '/logo.png');
          setIdSucursal(foundProduct.id_sucursal); // Guardar id_sucursal
        }
        if (data.estado_bodega) {
          setEstadoBodega(true);
          setInventarioBodega(data.inventario_bodega || []);
        }
      } catch (error) {
        console.error('Error al cargar el producto:', error);
      }
    };

    fetchProduct();
  }, [id]);

  useEffect(() => {
    const verificarSubscripcion = async () => {
      const userId = localStorage.getItem('usuario_id');
      try {
        const response = await axios.get(`https://integration.99envios.app/api/integration/shopify/v1/verificar-sucursal/${userId}`);
        if (response.data.message === 'El suscriptor está activo.') {
          setIsSubscribed(true);
          localStorage.setItem('codigoSucursal', response.data.codigo_sucursal);
        } else {
          setIsSubscribed(false);
        }
      } catch (error) {
        console.error('Error al verificar suscripción:', error);
        setIsSubscribed(false);
      }
    };
    verificarSubscripcion();
  }, []);

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  // New function to handle synchronization
  const handleSincronizarProducto = async () => {
    const codigoSucursal = localStorage.getItem('codigoSucursal');
    if (!codigoSucursal) {
      message.warning('No se encontró la sucursal registrada en Shopify.');
      return;
    }
    try {
      const response = await axios.get(
        `https://integration.99envios.app/api/integration/shopify/v1/sincronizarExternos/${product.id_producto}/${codigoSucursal}`
      );
      if(response.status === 201){
        message.success(response.data.message);
      } else{
        message.info('Sincronización completada.');
      }
    } catch (error) {
      console.error('Error al sincronizar:', error);
      if (error.response?.data?.message === "ya existe el producto en Shopify ") {
        message.error(error.response.data.message);
      } else {
        message.error('No se pudo sincronizar el producto');
      }
    }
  };

  // Añadir esta función antes del return
  const calcularPrecioConComision = (precio) => {
    const precioBase = parseFloat(precio);
    const comision = parseFloat(localStorage.getItem('porcentaje_comision')) || 0;
    // Primero convertir el porcentaje a decimal (ej: 1.5% -> 0.015)
    const comisionDecimal = comision / 100;
    // Luego calcular el valor de la comisión
    const valorComision = precioBase * comisionDecimal;
    
    console.log('Precio base:', precioBase);
    console.log('Porcentaje comisión:', comision + '%');
    console.log('Valor comisión:', valorComision);
    
    return precioBase + valorComision;
  };

  if (!product) {
    return <p>Cargando...</p>;
  }

  const images = product.imagenes.map(img => img.url_imagen);

  // Calcular el stock total en función de estado_bodega
  const totalStock = estadoBodega && inventarioBodega.length > 0
    ? inventarioBodega.reduce((acc, b) => acc + b.cantidad_disponible, 0)
    : product.cantidad_disponible;


  return (
    <>
      <NavbarDropshipping title={product.nombre_producto} />
      <div className="product-layout">
        <div className="product-card">
          <div className="product-card-header">
            <div className="product-image-section">
              <img
                src={selectedImage}
                alt={product.nombre_producto}
                className="product-image"
              />
              <div className="product-thumbnails">
                {images.map((image, index) => (
                  <img
                    key={index}
                    src={image}
                    alt={`Thumbnail ${index + 1}`}
                    className="thumbnail-image"
                    onClick={() => handleImageClick(image)}
                  />
                ))}
              </div>
            </div>
            <div className="product-info">
              <h2 className="product-title">{product.nombre_producto}</h2>
              <div className="product-sku-id">
                <p className="product-id">Id producto: {product.id_producto}</p>
                <p className="product-sku">SKU: {product.sku}</p>
              </div>
              <div className="product-tags">
                <span className="tag">{getCategoryName(product.id_categoria)}</span>
              </div>
              <p className="product-type">Tipo de producto: <strong>{product.estado_variacion ? 'Variable' : 'Simple'}</strong></p>
              <div className="product-pricing">
                <p className="product-price-provider">
                  Precio del proveedor: <strong>${calcularPrecioConComision(product.precio_proveedor).toLocaleString('es-CO')}</strong>
                 </p>
                <p className="product-price-suggested">
                  Precio sugerido: <strong>${calcularPrecioConComision(product.precio_sugerido).toLocaleString('es-CO')}</strong>
                 </p>
              </div>
              <p className="product-stock">
                Stock: <strong>{totalStock}</strong>
              </p>
              <div className="product-actions">
                <button
                  className="product-button primary"
                  onClick={() => handleButtonClick(product.precio_sugerido, totalStock, product.nombre_producto, product.id_producto)}
                >
                  Enviar al cliente
                </button>
                {isSubscribed && (
                  <button 
                    className="product-button primary"
                    onClick={handleSincronizarProducto}
                    style={{ marginLeft: '8px' }}
                  >
                    Sincronizar
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="product-card-details">
            <h3>Detalles</h3>
            <ul>
              <li>Descripción: {product.descripcion_producto}</li>
              <li>Peso: {product.peso_producto} {product.peso_producto === 1 ? 'kilogramo' : 'kilogramos'}</li>
              {product.informacion_adicional && (<li>Información adicional: {product.informacion_adicional}</li>)}
            </ul>
          </div>
          {product.estado_variacion === 1 && product.variaciones && product.variaciones.length > 0 && (
            <div className="product-card-details">
              <h3>Variaciones</h3>
              <ul>
                {product.variaciones.map((variacion, index) => (
                  <li key={index}>
                    Talla: {variacion.talla}, Color: {variacion.color}, Stock: {variacion.cantidad_disponible}, SKU: {variacion.sku}
                  </li>
                ))}
              </ul>
            </div>
          )}
          {sucursal && (
            <div className="product-card-details">
              <h3>Sucursal</h3>
              <ul>
                <li>Nombre de la sucursal: {sucursal.nombre_sucursal}</li>
                <li>Dirección: {sucursal.direccion}</li>
                <li>Teléfono: {sucursal.telefono}</li>
                <li>Contacto: {sucursal.nombre}</li>
              </ul>
            </div>
          )}
          {mostrarEnvios && (
            <div className="modal-overlay" onClick={handleCloseModal}>
              <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <SendClientPage 
                  suggestedPrice={suggestedPrice} 
                  precioProveedor={product.precio_proveedor}
                  stock={stock} 
                  name={name} 
                  prodID={prodID} 
                  estadoBodega={estadoBodega} 
                  inventarioBodega={inventarioBodega} 
                  variaciones={product.variaciones}
                  idSucursal={idSucursal}
                  peso_producto={product.peso_producto}
                />
                <button className="close-modal-btn" onClick={handleCloseModal}>
                  <CloseIcon />
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ProductCard;
